export default "__VITE_ASSET__CItSH6Kz__"